export const ArenaSlideType = {
	STANDARD: 'standard',
	EVENT:    'event',
};
